'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateInput = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _text = require('../forms/text');

var _text2 = _interopRequireDefault(_text);

var _util = require('./util');

var _dateInputLocal = require('./date-input.local.css');

var _dateInputLocal2 = _interopRequireDefault(_dateInputLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DateInput = exports.DateInput = function (_React$Component) {
  _inherits(DateInput, _React$Component);

  function DateInput() {
    _classCallCheck(this, DateInput);

    return _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).apply(this, arguments));
  }

  _createClass(DateInput, [{
    key: 'getDisplayString',
    value: function getDisplayString() {
      var selectedPeriod = this.props.selectedPeriod;
      var selectedDate = (0, _momentTimezone2.default)(selectedPeriod.date); // handle week as a special case

      if (selectedPeriod.type === 'week') {
        var weekOf = 'Week of ' + selectedDate.format('MMM D');

        if (this.isToDate()) {
          return weekOf + ' (to date)';
        }

        return weekOf + ', ' + selectedDate.year();
      }

      return '' + (0, _util.fromPeriodToDisplayString)(selectedPeriod) + (this.isToDate() ? ' (to date)' : '');
    }
  }, {
    key: 'isToDate',
    value: function isToDate() {
      var selectedPeriod = this.props.selectedPeriod;

      if (selectedPeriod.type === 'week') {
        return _momentTimezone2.default.range((0, _momentTimezone2.default)(selectedPeriod.date), (0, _momentTimezone2.default)(selectedPeriod.date).endOf('isoWeek')).contains((0, _momentTimezone2.default)());
      }

      var currentDate = (0, _momentTimezone2.default)();
      return (0, _util.isInPeriod)(selectedPeriod, {
        month: currentDate.month(),
        year: currentDate.year()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          inputClassName = _props.inputClassName,
          openDatepicker = _props.openDatepicker,
          label = _props.label,
          id = _props.id,
          theme = _props.theme;
      var displayValue = this.getDisplayString();
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(_dateInputLocal2.default.wrapper, className),
        title: displayValue
      }, _react2.default.createElement(_text2.default, {
        label: label,
        wrapperClassname: _dateInputLocal2.default.textInputWrapper,
        className: (0, _classnames2.default)([_dateInputLocal2.default.textInput, inputClassName, 'ignore-react-onclickoutside']),
        id: 'date',
        name: 'date',
        'data-auto': 'date-picker-input',
        type: 'text',
        placeholder: 'yyyy-mm-dd',
        value: displayValue,
        theme: theme,
        icon: 'calendar',
        iconColor: 'secondary',
        onFocus: function onFocus() {
          return openDatepicker(id);
        },
        readOnly: true
      }));
    }
  }]);

  return DateInput;
}(_react2.default.Component);

DateInput.propTypes = {
  className: _propTypes2.default.string,
  id: _propTypes2.default.string.isRequired,
  inputClassName: _propTypes2.default.string,
  label: _propTypes2.default.string,
  selectedPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(_constants2.default.datePickerPeriods),
    date: _propTypes2.default.string
  }).isRequired,
  theme: _propTypes2.default.oneOf(['classic', 'normal']),
  openDatepicker: _propTypes2.default.func.isRequired
};
exports.default = DateInput;